import Docs from './Docs';
import Resources from './Resources';
import GetStarted from './GetStarted';
import Community from './Community';
import { DOCS, RESOURCES, COMMUNITY, GETSTARTED } from '../../constants';

export default {
  [DOCS]: <Docs />,
  [RESOURCES]: <Resources />,
  [COMMUNITY]: <Community />,
  [GETSTARTED]: <GetStarted />,
};
